<mat-tab-group class="cn-mat-tab-group" [selectedIndex]="selectedTab()" (selectedIndexChange)="tabChange.emit($event)" data-testid="generic-tab-group">
  @for (tab of tabs(); track tab; let i = $index) {
    <mat-tab [label]="tab.label | translate" [disabled]="tab.disabled" [attr.data-testid]="'generic-tab-' + i">
      <ng-template mat-tab-label>
        {{ tab.label | translate }}
      </ng-template>
      <ng-template matTabContent>
        @if (i === selectedTab()) {
          <ng-content></ng-content>
        }
      </ng-template>
    </mat-tab>
  }
</mat-tab-group>